import {ManagerTable} from "@client/components/ManagerTable";
import * as typography from "@client/shared/typography";
import {ManagerLayout} from "@client/site/ManagerLayout";
import * as utils from "@client/utils";
import {server} from "@reactivated";
import React from "react";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.ClientManagerSurvey) => {
    const questions = props.workouts.map((workout) => workout.questions).flat();

    const questionTypes = questions.reduce<
        server.journal.workouts.QuestionType.output[]
    >(
        (acc, cur) =>
            acc.find((a) => a.uuid == cur.type.uuid) ? [...acc] : [...acc, cur.type],
        [],
    );

    const columns = [
        {name: "Date", accessor: "date", dataClassName: "w-52 truncate"},
    ].concat(
        questionTypes.map((questionType) => ({
            name: questionType.name,
            accessor: questionType.uuid,
            dataClassName: "w-[300px] whitespace-break-spaces!",
            headerClassName: "whitespace-normal text-pretty",
        })),
    );

    const values = props.workouts.map((workout) =>
        questionTypes.reduce<Record<string, React.ReactNode>>(
            (accumulator, questionType) => {
                const response = workout.questions.find(
                    (r) => r.type.uuid === questionType.uuid,
                );

                return {
                    ...accumulator,
                    [questionType.uuid]: response != null ? response.answer : "-",
                };
            },
            {
                date: utils.formatDate(workout.date!),
            },
        ),
    );

    return (
        <ManagerLayout title="Surveys" currentClientManagerId={props.client_manager.id}>
            <div className="space-y-4">
                <ClientNavigation>
                    <typography.Header>{props.client_manager.name}</typography.Header>
                </ClientNavigation>

                <ManagerTable columns={columns} values={values} />
            </div>
        </ManagerLayout>
    );
};
